import { textKeymap } from '@blocksuite/hive-inline-preset';
import { CodeBlockSchema } from '@blocksuite/hive-model';
import { KeymapExtension } from '@blocksuite/std';

export const CodeKeymapExtension = KeymapExtension(textKeymap, {
  flavour: CodeBlockSchema.model.flavour,
});
